import { Role } from './role';

export class User {
  id: number;
  userName: string;
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  phoneNumber: string;
  jobTitle: string;
  companyId: number;
  companyTypeId: number;
  companyName: string;
  permissions: string[];
  roles: string[];
  statusId: number;
  statusName: string;
  idDocumentNumber: string;
  idTypeId: number;
  idTypeName: string;
  isSaved: boolean;
  errorMessage: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/user.ts